import { Component, OnInit } from '@angular/core';
import { PartnerStateService } from '../../services/partner-state.service';
import { PartnerStateEnum } from '../../services/partner-state.enum';

@Component({
  selector: 'app-add-child-button',
  templateUrl: './add-child-button.component.html',
  styleUrls: ['./add-child-button.component.css']
})
export class AddChildButtonComponent implements OnInit {

  constructor (
    private partnerStateService: PartnerStateService
  ) {
  }

  ngOnInit() {
  }

  addChild() {
    this.partnerStateService.update(PartnerStateEnum.AddChild);
  }
}
